import { useContext, useEffect, useMemo } from "react";
import BeelditTableHeaderActions from "@beeldit/core/components/BeelditTableHeaderActions";
import { AuthContext } from "@beeldit/user-and-access/auth/AuthContext";
import { t } from "i18next";
import useEditAction from "../actions/edit/useEditAction";
import useListAction from "../actions/list/useListAction";
import { Card } from "react-bootstrap";
import getMainTableConfig from "@beeldit/ecommerce/combinations/configs/tableMainConfig";

function MainCombinationPage(props: any) {
  const { filters, formDefaultValues } = props;

  const { user } = useContext(AuthContext);

  const {
    indexFunction,
    actionTemplate: listActionTemplate,
    setTableConfig,
  } = useListAction(user, { ...filters, main: "1" }, false, false);

  const { getFunction, actionTemplate: editActionTemplate } =
    useEditAction(indexFunction);

  /**<newActionsHooks**/

  /**
   * Table configuration definition
   */
  const memoTableConfig = useMemo(
    () =>
      getMainTableConfig({
        indexFunction, // We pass the function to index the table
        getFunction, // We pass the function to get an element (used in the edit button)
        /**newActionsTableConfig**/
      }),
    [indexFunction, getFunction]
  );
  useEffect(() => {
    setTableConfig(memoTableConfig);
  }, [memoTableConfig, setTableConfig]);

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between">
        <Card.Title>{t("main_combination")}</Card.Title>
        <BeelditTableHeaderActions actions={memoTableConfig.actions} />
      </div>

      <div className="mt-3">
        {listActionTemplate}
        {editActionTemplate}
      </div>
    </div>
  );
}

export default MainCombinationPage;
